//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SfLink, SfIcon, SfButton, SfModal } from '@storefront-ui/vue';
import { ref } from '@nuxtjs/composition-api';
export default {
  components: {
    SfLink,
    SfIcon,
    SfButton,
    SfModal
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    isClose: {
      type: Boolean,
      default: true
    },
  },
  setup(prop, { root, emit }) {
    const visable = ref(prop.visable || false);
    const title = ref(prop.title || '');
    const context = ref(prop.context || '');
    const cancelText = prop.cancelText || root.$t('cancel');
    const okText = prop.okText || root.$t('confirm');
    const close = () => {
      visable.value = false;
      emit('close');
    };
    const open = () => {
      visable.value = true;
      emit('open');
    };
    const setModal = (data) => {
      title.value = data.title;
      context.value = data.context;
      open();
      console.log('setModal', data, visable.value);
    };
    const okConfirm = () => {
      emit('ok');
      visable.value = false;
    };
    return {
      visable,
      title,
      context,
      close,
      open,
      setModal,
      okConfirm,
      cancelText,
      okText,
    }
  }
}
